import React from "react"
import { Col, Form, Row } from "react-bootstrap"

function FormSectionTitle({ text }) {
  return (
    <Form.Group>
      <Row>
        <Col className="font-weight-bold">{text}</Col>
      </Row>
    </Form.Group>
  )
}
export default FormSectionTitle
